export default __webpack_public_path__ + "static/media/logo_horizontal_diet.bd7c8250.svg";